import type { JSX } from 'react';
import { ScreenContainer } from '~/singlePageApp/layouts/shared/ScreenContainer';

export const LoadingState = (): JSX.Element => <ScreenContainer />;
